import { render, staticRenderFns } from "./MortgageApplicationsSignWrapper.vue?vue&type=template&id=32c46ac2&scoped=true&"
import script from "./MortgageApplicationsSignWrapper.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationsSignWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationsSignWrapper.vue?vue&type=style&index=0&id=32c46ac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c46ac2",
  null
  
)

export default component.exports